/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_SpicesInputs */

const en_store_spices = /** @type {(inputs: Store_SpicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spices`)
};

const de_store_spices = /** @type {(inputs: Store_SpicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewürze`)
};

/**
* | output |
* | --- |
* | "Spices" |
*
* @param {Store_SpicesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const store_spices = /** @type {((inputs?: Store_SpicesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_SpicesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_store_spices(inputs)
	return en_store_spices(inputs)
});